import React, { useMemo, useState, useRef, useCallback, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Plus, ChevronLeft, ChevronRight } from "lucide-react";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../assets/Vehicles/search.png";
import { Columns } from "../Vehicles/Column";
import MOCK_DATA from "../Vehicles/MOCK_DATA.json";
import Offcanvas from "react-bootstrap/Offcanvas";
import chevron_down from "../../assets/Vehicles/chevron_down.png";
import upload from "../../assets/Vehicles/file.png";
import close from "../../assets/Vehicles/close_filter.png";
import customize from "../../assets/Vehicles/customize.png";
import down from "../../assets/Vehicles/chevron_down.png";
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";
import fill_chevron_down from "../../assets/Vehicles/fill_chevron_down.png";
import { useLocation, useNavigate } from "react-router-dom";
import { getIssueListApi, getIssueEditDetailsApi, getVehicleDetailsApi, getAttachmentListApi, getRemoveAttachmentApi, submitIssueAPI, updateIssueAPI, saveAttachmentApi } from "./issue-api.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import editIcon from "../../assets/svg/edit.svg";
import delIcon from "../../assets/svg/delete.svg";
import DeleteModal from "../common/delete-modal.js";
import { Toast, ToastContainer } from "react-bootstrap";
import CommonDropdown from "../common/common_dropDown";
import attachment from "../../assets/png/attachment.png";
import download from "../../assets/svg/download.svg";
import closeAttachment from "../../assets/svg/close-red.svg";
import DOMPurify from "dompurify";
import ErrorExtractor from "../common/error_extractor";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import { useGlobal } from "../../GlobalContext.js";

export function Issue() {
  const { rolePermissionList, userType } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();

  const { id } = location.state || {};

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null && deleteId !== 0) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setIsOpenDelete(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      getIssueList();
    }
  };

  useEffect(() => {
    if (id != null && id !== "" && id !== 0) {
      setShow(true);
      getIssueEditDetails(id);
    }
  }, [id]);

  const columns = [
    {
      header: "Issue ID",
      accessorKey: "issue_id",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Vehicle No & Name",
      accessorKey: "vehicle",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Reported Date",
      accessorKey: "reported_date",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Reported By",
      accessorKey: "reported_by",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Description",
      accessorKey: "description",
      cell: (info) => {
        console.log(info);
        return (
          <div
            className="hover-action-cell"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "200px",
            }}
          >
            <span>{info.getValue()}</span>
            <div className="click-actions">
              {checkPermission("Issue History", "edit_permission") && info.row.original.status === "Open" && (
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShow(true);
                    getIssueEditDetails(info.row.original.id);
                  }}
                >
                  <img src={editIcon} alt="edit" />
                </button>
              )}
              {checkPermission("Issue History", "delete_permission") && (
                <button
                  className="icon-btn"
                  title={info.row.original.status !== "Open" ? "Closed issues cannot be deleted" : "Delete issue"}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(info.row.original.id);
                  }}
                >
                  <img src={delIcon} alt="delete" />
                </button>
              )}
            </div>
          </div>
        );
      },
    },
  ];
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  const data = useMemo(() => MOCK_DATA, []);

  // Global filter (search)
  const [globalFilter, setGlobalFilter] = useState("");
  const [sortByValue, setSortByValue] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [sortByField, setSortByField] = useState("created");
  const [sortByDir, setSortByDir] = useState("desc");

  const [statusOption, setStatusOption] = useState(null);
  const [selectedDate, setSelectedDate] = useState();

  const [loading, setLoading] = useState(null);

  const sortByList = [
    { value: "name asc", label: "Name (Asc)" },
    { value: "name desc", label: "Name (Desc)" },
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];
  const statusList = [
    { value: "", label: "All" },
    { value: "Open", label: "Open" },
    { value: "InProgress", label: "InProgress" },
    { value: "Closed", label: "Closed" },
  ];

  const [issueList, setIssueList] = useState([]);
  const [listCount, setListCount] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getIssueList();
  }, [itemsPerPage, itemOffset, globalFilter, sortByValue, statusOption, selectedDate]);
  const getIssueList = async () => {
    try {
      /* &from_date=${fromCreatedDate}&to_date=${toCreatedDate}&status=${selectedStatus}&sort_field=${sortField}&sort_dir=${sortDir} */
      const response = await getIssueListApi(`search=${globalFilter}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortByField}&sort_dir=${sortByDir}&status=${statusOption != null ? statusOption.value : ""}&date=${selectedDate != null && selectedDate !== "" ? selectedDate.toLocaleDateString("en-CA") : ""}`);
      if (response.data.success === true) {
        setListCount(response.data.total_rec);
        setIssueList(response.data.issues);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % issueList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const table = useReactTable({
    data: issueList ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    resetField();
  };
  const handleShow = () => {
    setShow(true);
  };
  const fileInputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [removedAttachmentList, setRemovedAttachmentList] = useState([]);

  // const [activeBtn, setActiveBtn] = useState("details");
  const handleInputFile = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        /*  console.log("Base64 String:", base64String.toString());
         saveAttachment(await reader.result); */
        console.log("3..........");
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    }
  };
  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      /* const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl); */
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result; // this will be the byte code (base64String)
        /*  console.log("Base64 String:", base64String.toString());
           saveAttachment(await reader.result); */
        setAttachmentList([
          ...attachmentList,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleDelete = () => {
    setImage(null);
    fileInputRef.current.value = "";
  };
  const navigate = useNavigate();

  const handleRowClick = (rowData) => {
    navigate("/viewIssue", { state: { id: rowData.id } });
  };
  const { pageIndex, pageSize } = table.getState().pagination;
  const pageOptions = table.getPageOptions();

  const [issueDetails, setIssueDetails] = useState(null);

  const [issueName, setIssueName] = useState("");
  const [issueType, setIssueType] = useState(null);
  const [licensePlate, setLicensePlate] = useState(null);
  const [vendorOption, setVendorOption] = useState(null);
  const [vehicleName, setVehicleName] = useState("");
  const [VIN, setVIN] = useState("");
  const [issueDescription, setIssueDescription] = useState("");
  const resetField = () => {
    setIssueName("");
    setIssueType(null);
    setLicensePlate(null);
    setVendorOption(null);
    setVehicleName("");
    setVIN("");
    setIssueDescription("");
    setAttachmentList([]);
    setAttachmentURLList([]);
    setRemovedAttachmentList([]);
    setErrorMsg({
      vehicle_id: "",
      vendor_id: "",
      name: "",
      description: "",
      type: "",
      images: "",
    });
  };

  const handleSelectIssueType = (item) => {
    setIssueType(item);
  };
  const handleSelectVendor = (item) => {
    setVendorOption(item);
  };
  const handleSelectLicensePlate = (item) => {
    setLicensePlate(item);
    getVehicleDetails(item.value);
  };
  const getVehicleDetails = async (id) => {
    try {
      const response = await getVehicleDetailsApi(id);

      if (response.data.success === true) {
        setVehicleName(response.data.vehicle?.name ?? "");
        setVIN(response.data.vehicle?.vin ?? "");
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const [errorMsg, setErrorMsg] = useState({
    vehicle_id: "",
    vendor_id: "",
    name: "",
    description: "",
    type: "",
    images: "",
  });

  const getAttachmentList = async (issueId) => {
    try {
      const response = await getAttachmentListApi(issueId);

      if (response.data?.success === true) {
        setAttachmentURLList(response.data.attachments);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };
  const removeAttachment = async (attachmentId) => {
    try {
      const response = await getRemoveAttachmentApi(attachmentId);

      if (response.data?.success === true) {
        getAttachmentList();
      }
      if (response.data != null) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };

  const submitForm = async () => {
    setLoading(true); // Start loading
    const extractor = new ErrorExtractor();
    try {
      const preSanitizeData = {
        vehicle_id: licensePlate != null ? licensePlate.value : "",
        vendor_id: vendorOption != null ? vendorOption.value : "",
        name: issueName,
        description: issueDescription,
        type: issueType != null ? issueType.value : "",
        removed_images: removedAttachmentList ?? [],
        images: [],
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (issueDetails == null) {
        response = await submitIssueAPI(sanitizedData);
      } else {
        response = await updateIssueAPI(issueDetails.id, sanitizedData);
      }
      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            vehicle_id: "",
            vendor_id: "",
            name: "",
            description: "",
            type: "",
            images: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        if (attachmentList.length > 0) {
          saveAttachment(response.data.id);
        }
        getIssueList();
        resetField();
        setShow(false);
      }

      return response.data;
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && err.response.status === 400 && err.response.data.error) {
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const saveAttachment = async (issueId) => {
    try {
      const data = {
        attachment: attachmentList.map((item) => item.base64),
      };
      const response = await saveAttachmentApi(issueId, data);
      if (response.data.success === true) {
        setAttachmentList([]);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };
  const getIssueEditDetails = async (id) => {
    try {
      const response = await getIssueEditDetailsApi(id);

      if (response.data.success === true) {
        const issueDetail = response.data.issue ?? {};
        setIssueDetails(issueDetail);
        setIssueName(issueDetail.name ?? "");
        setIssueType({
          value: issueDetail.type ?? "",
          label: issueDetail.type ?? "",
        });
        setLicensePlate({
          value: issueDetail.vehicle_id ?? "",
          label: issueDetail.lic_no ?? "",
        });
        setVendorOption({
          value: issueDetail.vendor_value ?? "",
          label: issueDetail.vendor_label ?? "",
        });
        setVehicleName(issueDetail.vehicle_name ?? "");
        setVIN(issueDetail.vin ?? "");
        setIssueDescription(issueDetail.issue_description ?? "");
        setAttachmentURLList(issueDetail.images ?? []);
      } else {
        console.error("Error fetching issue details:", response.data.message);
        setShow(false);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const [hoveredRow, setHoveredRow] = useState(null);
  return (
    <div>
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999, position: "fixed" }}>
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      {isOpenDelete && <DeleteModal deleteUrl={`issue/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      <div className="d-flex p-3 flex-wrap align-items-center justify-content-between rounded-4" style={{ background: "#FFFFFF", margin: "16px" }}>
        <div className="d-flex flex-column">
          <p className="bg-transparent fw-bold dark-purple border-0 fs-24 assigned-dropdowns m-0">Issue history</p>
          <p className="text-muted">{listCount} records</p>
        </div>
        <div className="d-flex flex-wrap gap-3">
          <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
            <img src={search} alt="search" />
            <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.target.value)} />
          </div>
          {checkPermission("Issue History", "create_permission") && (
            <Button className="dark-purple-btn border-0 d-flex gap-1 px-3 rounded-3 text-white" onClick={handleShow}>
              <Plus />
              Add new
            </Button>
          )}
        </div>
        <Offcanvas show={show} onHide={handleClose} placement="end">
          <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center">
            <Offcanvas.Title>{issueDetails == null ? "New Issue" : "Update Issue"}</Offcanvas.Title>
            <button
              onClick={handleClose}
              style={{
                backgroundColor: "transparent",
                border: "2px solid #D4DDE7",
                color: "#172B4D",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              X
            </button>
          </Offcanvas.Header>
          <hr />
          <Offcanvas.Body className="pt-0">
            <div className="row p-2 pt-0">
              <div className="col-12 p-2 d-flex rounded-4 align-items-center my-2" style={{ border: "1px dashed #E5E5E5" }}>
                <div onClick={handleInputFile} onDrop={handleDrop} onDragOver={(e) => e.preventDefault()} onDragEnter={() => setDragging(true)} onDragLeave={() => setDragging(false)} className="d-flex align-items-center gap-3">
                  {image ? (
                    <img
                      src={image}
                      alt="Uploaded Vehicle"
                      className="rounded"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img src={upload} alt="Upload Icon" style={{ width: "60px", height: "60px" }} />
                  )}

                  <div className="d-flex flex-column">
                    <p className="fw-semibold m-0">Upload document</p>
                    <p className="m-0 fs-14 text-muted-grey">Add a document here by dragging & dropping, or choose files manually.</p>
                  </div>
                </div>

                {image ? (
                  <Button className="bg-danger border-0 text-white rounded-pill px-4 py-2 fw-500" onClick={handleDelete}>
                    Delete
                  </Button>
                ) : (
                  <Button className="bg-transparent choose-file-border-grey text-dark-purple rounded-pill px-4 py-2 fw-500" onClick={handleInputFile}>
                    Choose
                  </Button>
                )}

                <input type="file" accept="image/*" ref={fileInputRef} className="d-none" onChange={handleFileChange} />
              </div>
              {attachmentURLList.length > 0 && (
                <div
                  style={{
                    marginTop: "16px",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    gap: "16px",
                  }}
                >
                  {attachmentURLList.map((item, attachIndex) => (
                    <div
                      style={{
                        width: "312px",
                        height: "62px",
                        borderRadius: "12px",
                        padding: "12px 16px 12px 16px",
                        backgroundColor: "#F7F7F7",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img src={attachment} style={{ width: "37px", height: "36px" }} />
                      <div
                        style={{
                          width: "240px",
                          marginLeft: "8px",
                          marginTop: "4px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "500px",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                            marginBottom: "2px",
                          }}
                        >
                          {item.name}
                        </span>
                        <br />
                        <p
                          style={{
                            fontWeight: "400px",
                            fontSize: "12px",
                            lineHeight: "16.2px",
                            color: "#8790A1",
                          }}
                        >
                          {item.size}
                        </p>
                      </div>

                      {item.url && (
                        <div
                          onClick={() => {
                            downloadFile(item.url, item.url.split("/").pop());
                          }}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                          }}
                        >
                          <img
                            src={download}
                            style={{
                              width: "12.8px",
                              height: "12px",
                              top: "10px",
                              left: "9.6px",
                            }}
                          />
                        </div>
                      )}

                      <div
                        style={{
                          position: "relative",
                          width: "32px",
                          height: "32px",
                          borderRadius: "100px",
                          marginLeft: "4px",
                        }}
                      >
                        <img
                          src={closeAttachment}
                          style={{
                            width: "12.8px",
                            height: "12px",
                            top: "10px",
                            left: "9.6px",
                          }}
                          alt="remove"
                          onClick={() => {
                            /* removeAttachment(item.id); */
                            setRemovedAttachmentList([...removedAttachmentList, item.id]);
                            setAttachmentURLList(attachmentURLList.filter((_, i) => i !== attachIndex));
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {attachmentList.length > 0 && (
                <div
                  style={{
                    marginTop: "16px",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    gap: "16px",
                  }}
                >
                  {attachmentList.map((item, attachIndex) => (
                    <div
                      style={{
                        width: "312px",
                        height: "62px",
                        borderRadius: "12px",
                        padding: "12px 16px 12px 16px",
                        backgroundColor: "#F7F7F7",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img src={attachment} style={{ width: "37px", height: "36px" }} />
                      <div
                        style={{
                          width: "210px",
                          marginLeft: "8px",
                          marginTop: "4px",
                        }}
                      >
                        <div
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            fontWeight: "500px",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                            marginBottom: "2px",
                          }}
                        >
                          {item.name}
                        </div>
                        <p
                          style={{
                            fontWeight: "400px",
                            fontSize: "12px",
                            lineHeight: "16.2px",
                            color: "#8790A1",
                          }}
                        >
                          {item.size}
                        </p>
                      </div>

                      <div
                        style={{
                          position: "relative",
                          width: "32px",
                          height: "32px",
                          borderRadius: "100px",
                          marginLeft: "4px",
                        }}
                      >
                        <img
                          src={closeAttachment}
                          style={{
                            width: "12.8px",
                            height: "12px",
                            top: "10px",
                            left: "9.6px",
                          }}
                          onClick={() => {
                            setAttachmentList(attachmentList.filter((_, i) => i !== attachIndex));
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <p style={{ color: "#172B4D" }} className="fs-16 fw-600">
                Issue details
              </p>
              <div className="col-xl-6">
                <label htmlFor="issueName" className="form-label  fw-400 mb-1 d-flex">
                  Issue name <span className="error-text">*</span>
                </label>
                <input
                  type="text"
                  value={issueName}
                  className="form-control rounded-3 vehicle-form-input"
                  id="issueName"
                  placeholder="Enter here..."
                  onChange={(e) => {
                    setIssueName(e.target.value);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.name}
                </span>
              </div>
              <div className="col-xl-6 mt-2">
                <label htmlFor="plate" className="form-label  fw-400 mb-1">
                  Issue Type
                </label>
                <CommonDropdown apiUrl={`${apiUrl}get_issue_status`} placeholder="Select Issue Type" value={issueType} onSelect={handleSelectIssueType} />{" "}
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.type}
                </span>
              </div>
              <div className="col-xl-6  mt-2">
                <label htmlFor="type" className="form-label fw-400 mb-1 d-flex">
                  License Plate <span className="error-text">*</span>
                </label>
                <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select license plate" value={licensePlate} onSelect={handleSelectLicensePlate} />{" "}
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.vehicle_id}
                </span>
              </div>
              <div className="col-xl-6 mt-2">
                <label htmlFor="type" className="form-label fw-400 mb-1">
                  VIN
                </label>
                <input type="text" value={VIN} className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Auto-fill" readOnly={true} />
              </div>
              <div className="col-xl-12 mt-2">
                <label htmlFor="type" className="form-label fw-400 mb-1">
                  Vehicle Name
                </label>
                <input type="text" value={vehicleName} className="form-control rounded-3 vehicle-form-input" id="fill" placeholder="Auto-fill" readOnly={true} />
              </div>
              <div className="col-xl-12 mt-2">
                <label htmlFor="plate" className="form-label  fw-400 mb-1 d-flex">
                  Vendor <span className="error-text">*</span>
                </label>
                <CommonDropdown apiUrl={`${apiUrl}get_vendors`} placeholder="Select vendor" value={vendorOption} onSelect={handleSelectVendor} />{" "}
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.vendor_id}
                </span>
              </div>
              <div className="col-xl-12 mt-2">
                <label htmlFor="type" className="form-label fw-400 mb-1 d-flex">
                  Description <span className="error-text">*</span>
                </label>
                <textarea
                  type="text"
                  value={issueDescription}
                  className="form-control rounded-3 vehicle-form-input"
                  id="fill"
                  placeholder="Enter here"
                  rows={3}
                  onChange={(e) => {
                    setIssueDescription(e.target.value);
                  }}
                />
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "#FF4444",
                    marginTop: "6px",
                    marginLeft: "6px",
                  }}
                >
                  {errorMsg.description}
                </span>
              </div>
              <div className="d-flex gap-3 justify-content-end mt-5">
                <Button className="bg-white rounded-3 px-4 py-2 pagination-color btn-border-grey" onClick={handleClose} disabled={loading}>
                  Cancel
                </Button>
                <Button onClick={submitForm} className="dark-purple-btn rounded-3 py-2 px-4" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                      {issueDetails == null ? "Save" : "Update"}
                    </>
                  ) : issueDetails == null ? (
                    "Save"
                  ) : (
                    "Update"
                  )}
                </Button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        {/* Filters */}
        <div className="d-flex flex-wrap align-items-center justify-content-between p-3 gap-2 w-100">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <p className="m-0 text-filter-grey fw-semibold">Filter :</p>
            <Dropdown data-tooltip-id="sort-tooltip" data-tooltip-content="Sort by">
              <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                {sortByValue.label}
                <img src={fill_chevron_down} alt="chev down" />
                <img src={close} alt="x" />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                {sortByList.map((item) => (
                  <Dropdown.Item
                    onClick={() => {
                      const arr = item.value.split(" ");
                      if (arr.length > 1) {
                        setSortByField(arr[0]);
                        setSortByDir(arr[1]);
                      }
                      setSortByValue(item);
                    }}
                  >
                    {item.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
              <Tooltip id="sort-tooltip" place="top" />
            </Dropdown>
            <Dropdown data-tooltip-id="status-tooltip" data-tooltip-content="Status">
              <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                {statusOption != null ? statusOption.label : "Status"} <img src={fill_chevron_down} alt="chev down" />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                {statusList.map((item) => (
                  <Dropdown.Item
                    onClick={() => {
                      setStatusOption(item);
                    }}
                  >
                    {item.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
              <Tooltip id="status-tooltip" place="top" />
            </Dropdown>
            <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="date-tooltip" data-tooltip-content="Date">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="dd-mm-yyyy"
                customInput={
                  <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {selectedDate ? selectedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                    <Calendar size={16} />
                  </button>
                }
              />
              <Tooltip id="date-tooltip" place="top" />
              {selectedDate != null && <img onClick={() => setSelectedDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="p-3 w-100">
          <div className="table-wrapper overflow-x-auto">
            <table>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {header.column.getIsSorted() === "asc" && " asc"}
                        {header.column.getIsSorted() === "desc" && " des"}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row, index) => (
                  <tr
                    key={row.id}
                    style={{
                      position: "relative",
                      backgroundColor: hoveredRow === index ? "#F9F2FF" : "#ffffff",
                      cursor: "pointer",
                      transition: "border-color 0.3s",
                      borderLeft: hoveredRow === index ? "3px solid #471070" : "3px solid #E5E5E5",
                    }}
                    onClick={() => handleRowClick(row.original)}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} className="px-3 py-2">
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <Dropdown>
              <span className="pagination-color">Records per page: &nbsp;</span>
              <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                  {itemsPerPage} <img src={down} alt="" />
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                {[10, 25, 50, 75, 100].map((size) => (
                  <Dropdown.Item
                    key={size}
                    onClick={() => {
                      table.setPageSize(size);
                      setItemsPerPage(size);
                      setItemOffset(0);
                    }}
                    active={itemsPerPage === size}
                    className="text-center"
                  >
                    {size}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div className="d-flex align-items-center gap-2">
              <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
